var map = {
	"./Bars/icon-back-incircle": 7,
	"./Bars/icon-back-incircle.png": 7,
	"./Bars/icon-back-incircle@2x": 8,
	"./Bars/icon-back-incircle@2x.png": 8,
	"./Bars/icon-back-incircle@3x": 9,
	"./Bars/icon-back-incircle@3x.png": 9,
	"./SAPC5456": 10,
	"./SAPC5456.png": 10,
	"./aboutus/SAPC5456": 11,
	"./aboutus/SAPC5456.jpg": 11,
	"./aboutus/SAPC5456_3": 12,
	"./aboutus/SAPC5456_3.png": 12,
	"./aboutus/bg-about-yellow": 13,
	"./aboutus/bg-about-yellow.png": 13,
	"./aboutus/bg-center": 14,
	"./aboutus/bg-center.png": 14,
	"./aboutus/bg-cover": 15,
	"./aboutus/bg-cover.png": 15,
	"./aboutus/cover": 16,
	"./aboutus/cover.png": 16,
	"./aboutus/icon-mess": 17,
	"./aboutus/icon-mess.svg": 17,
	"./aboutus/kamill": 18,
	"./aboutus/kamill.png": 18,
	"./aicon-arrow-right-purple": 19,
	"./aicon-arrow-right-purple.svg": 19,
	"./alumni/Untitled-5": 20,
	"./alumni/Untitled-5.png": 20,
	"./alumni/bg": 21,
	"./alumni/bg.png": 21,
	"./alumni/content": 22,
	"./alumni/content.jpg": 22,
	"./alumni/header": 23,
	"./alumni/header.jpg": 23,
	"./alumni/laci": 24,
	"./alumni/laci.png": 24,
	"./alumni/logos": 25,
	"./alumni/logos.png": 25,
	"./alumni/sara": 26,
	"./alumni/sara.png": 26,
	"./bg-modal-left": 27,
	"./bg-modal-left.png": 27,
	"./brandmaker": 28,
	"./brandmaker.png": 28,
	"./brandmaker_mobile": 29,
	"./brandmaker_mobile.png": 29,
	"./business/cards/technology": 30,
	"./business/cards/technology-hover": 31,
	"./business/cards/technology-hover.png": 31,
	"./business/cards/technology.png": 30,
	"./business/design-timeline": 32,
	"./business/design-timeline-mobile": 33,
	"./business/design-timeline-mobile.svg": 33,
	"./business/design-timeline.svg": 32,
	"./business/sd-timeline": 34,
	"./business/sd-timeline-mobile": 35,
	"./business/sd-timeline-mobile.svg": 35,
	"./business/sd-timeline.svg": 34,
	"./business/transformation-timeline": 36,
	"./business/transformation-timeline.svg": 36,
	"./contacts/dani": 37,
	"./contacts/dani.png": 37,
	"./contacts/kamill": 38,
	"./contacts/kamill.png": 38,
	"./contacts/sara": 39,
	"./contacts/sara.png": 39,
	"./education/SAPC5456": 40,
	"./education/SAPC5456.png": 40,
	"./education/avatar-eniko": 41,
	"./education/avatar-eniko.png": 41,
	"./education/avatar-nikolett": 42,
	"./education/avatar-nikolett.png": 42,
	"./education/avatar-orsolya": 43,
	"./education/avatar-orsolya.png": 43,
	"./education/content-image": 44,
	"./education/content-image.jpg": 44,
	"./education/cover": 45,
	"./education/cover.png": 45,
	"./education/icon-circle": 46,
	"./education/icon-circle.svg": 46,
	"./education/zuglo_lego1_2": 47,
	"./education/zuglo_lego1_2.jpg": 47,
	"./employees/bernadett": 48,
	"./employees/bernadett.png": 48,
	"./employees/dani": 49,
	"./employees/dani.png": 49,
	"./employees/eszter": 50,
	"./employees/eszter.png": 50,
	"./employees/job": 51,
	"./employees/job.png": 51,
	"./employees/kamill": 52,
	"./employees/kamill.png": 52,
	"./employees/laci": 53,
	"./employees/laci.png": 53,
	"./employees/sara": 54,
	"./employees/sara.png": 54,
	"./employees/tonka": 55,
	"./employees/tonka.png": 55,
	"./employees/zsofi": 56,
	"./employees/zsofi.png": 56,
	"./icon-3arrows": 57,
	"./icon-3arrows.svg": 57,
	"./icon-accordion-closed": 58,
	"./icon-accordion-closed.svg": 58,
	"./icon-accordion-edu-open": 59,
	"./icon-accordion-edu-open.svg": 59,
	"./icon-accordion-opened": 60,
	"./icon-accordion-opened.svg": 60,
	"./icon-appearances": 61,
	"./icon-appearances.svg": 61,
	"./icon-arrow-down-carnation": 62,
	"./icon-arrow-down-carnation.svg": 62,
	"./icon-arrow-down-long-carnation": 63,
	"./icon-arrow-down-long-carnation.svg": 63,
	"./icon-arrow-right-carnation": 64,
	"./icon-arrow-right-carnation.svg": 64,
	"./icon-arrow-right-purpleHeart": 65,
	"./icon-arrow-right-purpleHeart.svg": 65,
	"./icon-arrow-right-white": 66,
	"./icon-arrow-right-white.svg": 66,
	"./icon-arrow-right-yellow": 67,
	"./icon-arrow-right-yellow.svg": 67,
	"./icon-arrow-rotated-yellow": 68,
	"./icon-arrow-rotated-yellow.svg": 68,
	"./icon-bank": 69,
	"./icon-bank.svg": 69,
	"./icon-blog": 70,
	"./icon-blog.svg": 70,
	"./icon-booster": 71,
	"./icon-booster.svg": 71,
	"./icon-booster2": 72,
	"./icon-booster2.svg": 72,
	"./icon-brand-positioning": 73,
	"./icon-brand-positioning.svg": 73,
	"./icon-business-decisions": 74,
	"./icon-business-decisions.svg": 74,
	"./icon-business-model": 75,
	"./icon-business-model.svg": 75,
	"./icon-calendar": 76,
	"./icon-calendar.svg": 76,
	"./icon-challanger": 77,
	"./icon-challanger.svg": 77,
	"./icon-change": 78,
	"./icon-change.svg": 78,
	"./icon-changebydesign": 79,
	"./icon-changebydesign.svg": 79,
	"./icon-changer": 80,
	"./icon-changer.svg": 80,
	"./icon-checkbox-off": 81,
	"./icon-checkbox-off.svg": 81,
	"./icon-checkbox-off2": 82,
	"./icon-checkbox-off2.svg": 82,
	"./icon-checkbox-on": 83,
	"./icon-checkbox-on.svg": 83,
	"./icon-checkbox-on2": 84,
	"./icon-checkbox-on2.svg": 84,
	"./icon-checkbox2-off": 85,
	"./icon-checkbox2-off.svg": 85,
	"./icon-checkbox2-on": 86,
	"./icon-checkbox2-on.svg": 86,
	"./icon-circle": 87,
	"./icon-circle.svg": 87,
	"./icon-close-lsd": 88,
	"./icon-close-lsd.svg": 88,
	"./icon-company-plan": 89,
	"./icon-company-plan.svg": 89,
	"./icon-conscious": 90,
	"./icon-conscious.svg": 90,
	"./icon-construction": 91,
	"./icon-construction.svg": 91,
	"./icon-contact-dots": 92,
	"./icon-contact-dots-white": 93,
	"./icon-contact-dots-white.svg": 93,
	"./icon-contact-dots.svg": 92,
	"./icon-customer-centric-strategy": 94,
	"./icon-customer-centric-strategy.svg": 94,
	"./icon-customer-journey": 95,
	"./icon-customer-journey.svg": 95,
	"./icon-dots": 96,
	"./icon-dots-black": 97,
	"./icon-dots-black.svg": 97,
	"./icon-dots.svg": 96,
	"./icon-dots2": 98,
	"./icon-dots2.svg": 98,
	"./icon-edu-card-carbon": 99,
	"./icon-edu-card-carbon.svg": 99,
	"./icon-edu-card-darkpurple": 100,
	"./icon-edu-card-darkpurple.svg": 100,
	"./icon-edu-card-gray": 101,
	"./icon-edu-card-gray.svg": 101,
	"./icon-edu-card-lightpurple": 102,
	"./icon-edu-card-lightpurple.svg": 102,
	"./icon-edu-card-yellow": 103,
	"./icon-edu-card-yellow.svg": 103,
	"./icon-edu-check": 104,
	"./icon-edu-check.svg": 104,
	"./icon-experience": 105,
	"./icon-experience-strategy": 106,
	"./icon-experience-strategy.svg": 106,
	"./icon-experience.svg": 105,
	"./icon-explorer": 107,
	"./icon-explorer.svg": 107,
	"./icon-focus": 108,
	"./icon-focus.svg": 108,
	"./icon-folder": 109,
	"./icon-folder.svg": 109,
	"./icon-footer-arrow": 110,
	"./icon-footer-arrow.svg": 110,
	"./icon-footer-meet-logo": 111,
	"./icon-footer-meet-logo.svg": 111,
	"./icon-foryou": 112,
	"./icon-foryou.svg": 112,
	"./icon-foryourorg": 113,
	"./icon-foryourorg.svg": 113,
	"./icon-foryourteam": 114,
	"./icon-foryourteam.svg": 114,
	"./icon-grid-plus": 115,
	"./icon-grid-plus.svg": 115,
	"./icon-hamburger-black": 116,
	"./icon-hamburger-black.svg": 116,
	"./icon-hamburger-white": 117,
	"./icon-hamburger-white.svg": 117,
	"./icon-hamburger.black": 118,
	"./icon-hamburger.black.svg": 118,
	"./icon-idea-collection": 119,
	"./icon-idea-collection.svg": 119,
	"./icon-indent": 120,
	"./icon-indent.svg": 120,
	"./icon-info": 121,
	"./icon-info.svg": 121,
	"./icon-inhouse-design": 122,
	"./icon-inhouse-design.svg": 122,
	"./icon-journey": 123,
	"./icon-journey.svg": 123,
	"./icon-knowledge": 124,
	"./icon-knowledge.svg": 124,
	"./icon-leader": 125,
	"./icon-leader.svg": 125,
	"./icon-lifecycle": 126,
	"./icon-lifecycle.svg": 126,
	"./icon-lsd-arrow-down": 127,
	"./icon-lsd-arrow-down.svg": 127,
	"./icon-lsd-close": 128,
	"./icon-lsd-close.svg": 128,
	"./icon-main-edu-plus": 129,
	"./icon-main-edu-plus.svg": 129,
	"./icon-map": 130,
	"./icon-map.svg": 130,
	"./icon-meet-mobile": 131,
	"./icon-meet-mobile-white": 132,
	"./icon-meet-mobile-white.svg": 132,
	"./icon-meet-mobile.svg": 131,
	"./icon-original": 133,
	"./icon-original.svg": 133,
	"./icon-our-work": 134,
	"./icon-our-work.svg": 134,
	"./icon-persona": 135,
	"./icon-persona.svg": 135,
	"./icon-personal-plan": 136,
	"./icon-personal-plan.svg": 136,
	"./icon-plus": 137,
	"./icon-plus-big": 138,
	"./icon-plus-big.svg": 138,
	"./icon-plus-yellow": 139,
	"./icon-plus-yellow.svg": 139,
	"./icon-plus.svg": 137,
	"./icon-post-rectangle": 140,
	"./icon-post-rectangle.png": 140,
	"./icon-problem": 141,
	"./icon-problem.svg": 141,
	"./icon-publications": 142,
	"./icon-publications.svg": 142,
	"./icon-reddot": 143,
	"./icon-reddot.svg": 143,
	"./icon-redesign-service": 144,
	"./icon-redesign-service.svg": 144,
	"./icon-reflexive": 145,
	"./icon-reflexive.svg": 145,
	"./icon-sensemaking": 146,
	"./icon-sensemaking.svg": 146,
	"./icon-separation": 147,
	"./icon-separation.svg": 147,
	"./icon-shop-success": 148,
	"./icon-shop-success.svg": 148,
	"./icon-solution": 149,
	"./icon-solution.svg": 149,
	"./icon-square": 150,
	"./icon-square-purple": 151,
	"./icon-square-purple.svg": 151,
	"./icon-square.svg": 150,
	"./icon-starter": 152,
	"./icon-starter.svg": 152,
	"./icon-strategic-advice": 153,
	"./icon-strategic-advice.svg": 153,
	"./icon-tag-close": 154,
	"./icon-tag-close.svg": 154,
	"./icon-teamwork": 155,
	"./icon-teamwork.svg": 155,
	"./icon-testimonials": 156,
	"./icon-testimonials.svg": 156,
	"./icon-timeline": 157,
	"./icon-timeline.svg": 157,
	"./icon-transform": 158,
	"./icon-transform.svg": 158,
	"./icon-transformation": 159,
	"./icon-transformation.svg": 159,
	"./icon-undestanding": 160,
	"./icon-undestanding.svg": 160,
	"./icon-validated-prototyles": 161,
	"./icon-validated-prototyles.svg": 161,
	"./icon-value-proposition": 162,
	"./icon-value-proposition.svg": 162,
	"./icon-wand": 163,
	"./icon-wand.svg": 163,
	"./logo-changer": 164,
	"./logo-changer.svg": 164,
	"./logo-header": 165,
	"./logo-header.svg": 165,
	"./logo-meet-squared": 166,
	"./logo-meet-squared.svg": 166,
	"./logos/logo-corvinus": 167,
	"./logos/logo-corvinus.svg": 167,
	"./logos/logo-deloitte": 168,
	"./logos/logo-deloitte.svg": 168,
	"./logos/logo-elte": 169,
	"./logos/logo-elte.svg": 169,
	"./logos/logo-eon": 170,
	"./logos/logo-eon.svg": 170,
	"./logos/logo-fundation": 171,
	"./logos/logo-fundation.svg": 171,
	"./logos/logo-knowledge": 172,
	"./logos/logo-knowledge-white": 173,
	"./logos/logo-knowledge-white.svg": 173,
	"./logos/logo-knowledge.svg": 172,
	"./logos/logo-masters": 174,
	"./logos/logo-masters.svg": 174,
	"./logos/logo-met": 175,
	"./logos/logo-met.svg": 175,
	"./logos/logo-mindset": 176,
	"./logos/logo-mindset-white": 177,
	"./logos/logo-mindset-white.svg": 177,
	"./logos/logo-mindset.svg": 176,
	"./logos/logo-rafi": 178,
	"./logos/logo-rafi.svg": 178,
	"./logos/logo-roche": 179,
	"./logos/logo-roche.svg": 179,
	"./logos/logo-services": 180,
	"./logos/logo-services-white": 181,
	"./logos/logo-services-white.svg": 181,
	"./logos/logo-services.svg": 180,
	"./logos/logo-us": 182,
	"./logos/logo-us-white": 183,
	"./logos/logo-us-white.svg": 183,
	"./logos/logo-us.svg": 182,
	"./logos/logo-works": 184,
	"./logos/logo-works-white": 185,
	"./logos/logo-works-white.svg": 185,
	"./logos/logo-works.svg": 184,
	"./logos/magnet": 186,
	"./logos/magnet.png": 186,
	"./logos/mcdonalds": 187,
	"./logos/mcdonalds.png": 187,
	"./logos/rajk": 188,
	"./logos/rajk.svg": 188,
	"./logos/telenor": 189,
	"./logos/telenor.png": 189,
	"./main/SAPC5456": 190,
	"./main/SAPC5456.png": 190,
	"./main/cover": 2,
	"./main/cover.jpg": 238,
	"./main/cover.png": 2,
	"./main/main-future": 191,
	"./main/main-future.jpg": 191,
	"./main/main-future2": 192,
	"./main/main-future2.jpg": 192,
	"./main/team": 193,
	"./main/team.jpg": 193,
	"./mindset/content-image": 194,
	"./mindset/content-image-mobile": 195,
	"./mindset/content-image-mobile.png": 195,
	"./mindset/content-image.png": 194,
	"./mindset/content-image2": 196,
	"./mindset/content-image2.jpg": 196,
	"./mindset/icon-mindset": 197,
	"./mindset/icon-mindset.svg": 197,
	"./posts/post": 198,
	"./posts/post.png": 198,
	"./shop/icon-education": 199,
	"./shop/icon-education.svg": 199,
	"./shop/icon-mindset": 200,
	"./shop/icon-mindset.svg": 200,
	"./shop/icon-rectangle": 201,
	"./shop/icon-rectangle.svg": 201,
	"./shop/icon-service": 202,
	"./shop/icon-service.svg": 202,
	"./shop/logo-doctor": 203,
	"./shop/logo-doctor.png": 203,
	"./shop/logo-doki": 204,
	"./shop/logo-doki.png": 204,
	"./shop/logo-hyper": 205,
	"./shop/logo-hyper.png": 205,
	"./shop/logo-meet": 206,
	"./shop/logo-meet-white": 207,
	"./shop/logo-meet-white.svg": 207,
	"./shop/logo-meet.png": 206,
	"./shop/logo-roche": 208,
	"./shop/logo-roche.png": 208,
	"./shop/rectangle": 209,
	"./shop/rectangle.png": 209,
	"./shop/shop-cover": 1,
	"./shop/shop-cover.jpeg": 239,
	"./shop/shop-cover.jpg": 240,
	"./shop/shop-cover.png": 1,
	"./shop/shop-cover2": 210,
	"./shop/shop-cover2.jpg": 210,
	"./shop/whiteboard": 211,
	"./shop/whiteboard.jpg": 211,
	"./signatures/2024/bettina": 212,
	"./signatures/2024/bettina.png": 212,
	"./signatures/2024/janka": 213,
	"./signatures/2024/janka.png": 213,
	"./signatures/2024/kamil": 214,
	"./signatures/2024/kamil.png": 214,
	"./signatures/2024/laci": 215,
	"./signatures/2024/laci.png": 215,
	"./signatures/2024/sara": 216,
	"./signatures/2024/sara.png": 216,
	"./signatures/2024/zsofi": 217,
	"./signatures/2024/zsofi.png": 217,
	"./signatures/content-bg-4": 218,
	"./signatures/content-bg-4.png": 218,
	"./signatures/cover-bg": 219,
	"./signatures/cover-bg-2021": 220,
	"./signatures/cover-bg-2021.png": 220,
	"./signatures/cover-bg-2024": 221,
	"./signatures/cover-bg-2024.png": 221,
	"./signatures/cover-bg-3": 222,
	"./signatures/cover-bg-3.png": 222,
	"./signatures/cover-bg.png": 219,
	"./signatures/kamill_signature_black": 3,
	"./signatures/kamill_signature_black.jpg": 241,
	"./signatures/kamill_signature_black.png": 3,
	"./signatures/kamill_signature_white": 223,
	"./signatures/kamill_signature_white.png": 223,
	"./signatures/laci_signature_black": 4,
	"./signatures/laci_signature_black.jpg": 242,
	"./signatures/laci_signature_black.png": 4,
	"./signatures/laci_signature_white": 224,
	"./signatures/laci_signature_white.png": 224,
	"./signatures/sara_black": 5,
	"./signatures/sara_black.jpg": 243,
	"./signatures/sara_black.png": 5,
	"./signatures/sara_white": 225,
	"./signatures/sara_white.png": 225,
	"./signatures/zsofi_signature_black": 6,
	"./signatures/zsofi_signature_black.jpg": 244,
	"./signatures/zsofi_signature_black.png": 6,
	"./signatures/zsofi_signature_white": 226,
	"./signatures/zsofi_signature_white.png": 226,
	"./testimonials/logo-telenor": 227,
	"./testimonials/logo-telenor.svg": 227,
	"./testimonials/telenor": 228,
	"./testimonials/telenor.png": 228,
	"./us": 229,
	"./us.jpg": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 237;